import { Box, CircularProgress } from "@mui/material";
import type { FC } from "react";
import { useHospitalData } from "../../../contexts/HospitalDataProvider";
import { AgencyShiftSettings } from "./AgencyShiftSettings";
import { AgencyWagesTable } from "./AgencyWagesTable";
import { useAgencyWages } from "./useAgencyWages";

export const AgencyWages: FC = () => {
	const { chosenDepartment } = useHospitalData();
	const { agencyWages, isLoading, isSaving, saveAgencyWages, deleteAgencyWage } = useAgencyWages();

	if (isLoading) {
		return (
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					p: 4,
				}}
			>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<Box sx={{ width: "100%", flex: 1, minHeight: 0, display: "flex", flexDirection: "column", gap: 1 }}>
			{/* flexShrink: 0 keeps the settings section at its natural height; the grid (height: 100%)
			    then fills only the remaining space instead of overlaying the section above it. */}
			<Box sx={{ flexShrink: 0 }}>
				<AgencyShiftSettings key={chosenDepartment.department_id} />
			</Box>
			<Box sx={{ flex: 1, minHeight: 0 }}>
				<AgencyWagesTable
					departmentId={chosenDepartment.department_id}
					agencyWages={agencyWages}
					isSaving={isSaving}
					onSave={saveAgencyWages}
					onDelete={deleteAgencyWage}
				/>
			</Box>
		</Box>
	);
};
